// 复制文本到剪贴板
// 优先调用浏览器异步接口
export function copy(text: string): Promise<void> {
  if (navigator.clipboard) {
    // return navigator.clipboard.writeText(text);
    navigator.clipboard.writeText(text).then(() => {
      return Promise.resolve()
    }).catch(e => {
      // 没有写入权限
    });
  }
  return copyTextToClipboard(text) ? Promise.resolve() : Promise.reject();
}

// https://github.com/sindresorhus/copy-text-to-clipboard
// 必须在用户事件中触发，比如 click keyup 之类的
function copyTextToClipboard(input: string): boolean {
  const element = document.createElement("textarea");
  element.value = input;
  // Prevent keyboard from showing on mobile
  element.setAttribute("readonly", "");
  element.style.contain = "strict";
  element.style.position = "absolute";
  element.style.left = "-9999px";
  element.style.fontSize = "12pt"; // Prevent zooming on iOS
  const selection = document.getSelection();
  const originalRange =
    selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
  // append to page
  document.body.append(element);
  element.select();
  // Explicit selection workaround for iOS
  element.selectionStart = 0;
  element.selectionEnd = input.length;
  let isSuccess = false;
  try {
    isSuccess = document.execCommand("copy");
  } catch {
    //
  }
  element.remove();
  if (originalRange && selection) {
    selection.removeAllRanges();
    selection.addRange(originalRange);
  }
  return isSuccess;
}
